export const MACHINE_DOCUMENTS_RESOURCES = process.env.REACT_APP_RESOURCES_URL + "/Resources/machinedocs";
export const MACHINE_CATALOG_PDF_RESOURCES = process.env.REACT_APP_RESOURCES_URL + "/Resources/machinecatalogpdf";
export const PARTS_RESOURCES = process.env.REACT_APP_RESOURCES_URL + "/Resources/parts";
export const DRAWINGS_RESOURCES = process.env.REACT_APP_RESOURCES_URL + "/Resources/drawings";
export const MACHINES_RESOURCES = process.env.REACT_APP_RESOURCES_URL + "/Resources/machines";
export const LOGO_RESOURCES =
    process.env.REACT_APP_RESOURCES_URL + "/Resources/logoimages";
